import { entityKeyOf, moduleKeyOf } from '@platform/core/lib/modulePaths';
import { NEW_RECORD_ID } from '@platform/engine/form/create/newRecordId';
import type { IRouteKeys } from './IRouteKeys';

const GUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** Чи сегмент після сутності — запис (GUID або `new` — нова повна форма), а не ключ подання. */
export const isRecordSegment = (segment: string): boolean => segment === NEW_RECORD_ID || GUID.test(segment);

/**
 * Ключі маршруту з параметрів роутера (ADR-028): `module` — slug модуля → ключ; `entityOrPage` — сутність модуля (тип запису) або сторінка
 * модуля; `idOrView` під сутністю — запис (isRecordSegment) або подання. Параметри сторінок оболонки (`view` «Моєї роботи», `item`) — як є.
 */
export function routeKeysOf(params: Readonly<Partial<Record<string, string>>>): IRouteKeys {
  const module = params.module ? moduleKeyOf(params.module) : '';
  const segment = params.entityOrPage;
  const rt = module && segment ? entityKeyOf(module, segment) ?? '' : '';
  const sub = rt ? params.idOrView : undefined;
  const id = sub && isRecordSegment(sub) ? sub : '';
  return {
    module, rt, id, view: sub && !id ? sub : params.view, tab: params.tab, page: module && segment && !rt ? segment : undefined, item: params.item,
  };
}
